import { useState, useEffect, useCallback, useRef } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { GetUserVideo, getVideo } from '../../../s3Func/s3Download';
import MediaService from '../../../services/MediaService';
import { replaceCredentials } from '../../../utils';
import './SlideShow.scss';
import PopUp from './../../../Popup/logoutPopup'
import { sleep } from '../../../utils/index';

const SlideShow = ({
  song,
  recording,
  jsonUrl,
  module,
  moduleName,
  background,
  onClose,
  onCloseBtnClick,
  openPhotoTime,
}) => {
  // Sets up the initial variables to be used later
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);

  const closeBtnImage = MediaService.getImage('/Images/close.png', login);
  const captionsImage = MediaService.getImage(
    '/Module1Images/SubtitleIcon_On.png',
    login
  );
  const [slidesData, setSlidesData] = useState({});

  const [activeCaptions, setActiveCaptions] = useState(true);
  const [notification, setNotification] = useState(false);


  const [currentLyric, setCurrentLyric] = useState(0);
  const [currentSlide, setCurrentSlide] = useState(0);

  const audioEl = useRef();
  const recordEl = useRef();
  const animationInterval = useRef(0);

  const slideIdx = useRef(0);
  const lyricIdx = useRef(0);

  function areClose(num1, num2, tolerance) {
    return Math.abs(num1 - num2) <= tolerance;
  }

  const animateSlideshow = useCallback((config) => {
    if (
      slideIdx.current + 1 >= config.photos.length
      &&
      lyricIdx.current + 1 >= config.keywords.length
    ) {
      return;
    }

    const activeSlide = config.photos[slideIdx.current + 1];
    const activeLyric = config.keywords[lyricIdx.current + 1];

    const currentSongTime =
    Math.round(audioEl.current.currentTime * 100) / 100;

    if (activeLyric && activeLyric.time !== null) {
      if (areClose(activeLyric.time, currentSongTime, 0.1)) {
        lyricIdx.current = lyricIdx.current + 1;
        setCurrentLyric(lyricIdx.current);
      }
    }

    if (activeSlide && activeSlide.time !== null) {
      if (areClose(activeSlide.time, currentSongTime, 0.1)) {
        slideIdx.current = slideIdx.current + 1;
        setCurrentSlide(slideIdx.current);
      }
    }

  }, []);

  const startAnimations = useCallback(
    async (data) => {
      const slidesConfig = await data;
      if (slidesConfig) {
        animationInterval.current = setInterval(() =>
          animateSlideshow(slidesConfig), 100
        );
      }
    },
    [animateSlideshow]
  );

  const getConfiguration = useCallback(async () => {
    const config = await getVideo(jsonUrl, login);

    let data = await fetch(config);
    data = await data.json();
    if(moduleName === "MODULE4"){
      data.keywords[8].word = "want to"
    }
    if(moduleName === "MODULE5"){
      data.keywords[1].word = "when I talk to"
    }

    data.photos = await Promise.all(
      data.photos.map(async (slide) => {
        let photoLink = `${slide.photoName}.jpg`;
        if (module.currentday < 4) {
          photoLink = await getVideo(photoLink, login);
        } else {
          photoLink = replaceCredentials(
            photoLink,
            module.StudentID,
            login.influencerid
          );
          photoLink = await GetUserVideo(photoLink);
        }

        return {
          photoName: photoLink,
          time: slide.time,
        };
      })
    );

    data.keywords.unshift({ word: '', time: 0 });

    if (song) {
      if (!audioEl.current.src) {
        audioEl.current.src = song;
        await audioEl.current.play();
        audioEl.current.onended = () => onClose(true);
      }
    }

    if (recording) {
      if (!recordEl.current.src) {
        recordEl.current.src = recording;
        await recordEl.current.play();
      }
    }

    if(audioEl.current.src && recordEl.current.src) {
      sleep(3000).then(() => {
        if(recordEl.current.currentTime !== audioEl.current.currentTime) {
          audioEl.current.currentTime = recordEl.current.currentTime;
        }
      });
    }


    setSlidesData(data);
    // startAnimations(data);
    const slidesConfig = await data;
    animationInterval.current = setInterval(() =>
      animateSlideshow(slidesConfig), 100
    );
  }, [
    onClose,
    song,
    startAnimations,
    jsonUrl,
    login.influencerid,
    module.StudentID,
    module.currentday,
    recording,
  ]);

  useEffect( () => {
    setCurrentSlide(0);
    setCurrentLyric(0);

    getConfiguration();

    return () => {
      if (animationInterval.current) {
        clearInterval(animationInterval.current);
      }
    };
  }, []);

  const handleImageError =() =>{
    audioEl.current.pause();
    recordEl.current.pause();
    setNotification(true);
  }

  const captionsButtonHandler = () => {
    setActiveCaptions(!activeCaptions);
    if (!window.location.href.includes('wearefriends.cool') ) {
      onClose(true);
    }
    if (window.location.href.includes('staging') ) {
      onClose(true);
    }
  };

  const handleCloseClick = () => {
    clearInterval(animationInterval.current);
    onCloseBtnClick();
  };

  return (
    <>
      {notification && (
          <PopUp
            content={
              <>
                <b id='title'>
                  Uh-oh! Your photos didn't save. 
                  <br />
                  Go back to day 4 Photo Time and take your photos again.
                  <br />
                </b>
                <button
                  id='logoutButton1'
                  className='logoutButton'
                  onClick={() => {
                    openPhotoTime();
                    handleCloseClick();
                  }}
                >
                  Take photos
                </button>
                <button
                  id='logoutButton2'
                  className='logoutButton'
                  onClick={() => {
                    audioEl.current.play();
                    recordEl.current.play();
                    setNotification(false);
                  }}
                >
                  No photos
                </button>
              </>
            }
            handleClose={() => setNotification(false)}
          />
        )}
      <button className='slideshow-backBtn' onClick={handleCloseClick}>
        <img alt='close' src={closeBtnImage} />
      </button>

      <audio ref={audioEl}></audio>
      <audio ref={recordEl}></audio>

      <button
        className='slideshow-captions-btn'
        onClick={captionsButtonHandler}
      >
        <img alt='captions' src={captionsImage} />
      </button>

      <div
        className='slideshow-container'
        style={{ backgroundImage: `url(${background})` }}
      >
        <>
          {slidesData.photos &&
            slidesData.photos.map((slide, index) => {
              return (
                <img
                  // style={{
                  //   backgroundImage: `url(${slide.photoName})`,
                  // }}
                  alt="slides"
                  src={slide.photoName}
                  className={
                    index === currentSlide
                      ? 'photo-slide current'
                      : 'photo-slide'
                  }
                  onError={handleImageError}
                  key={`slide_${index}`}
                ></img>
              );
            })}
          {slidesData.keywords && activeCaptions &&
            slidesData.keywords.map((lyric, index) => {
              return (
                <div
                  className={
                    index === currentLyric && lyric.word
                      ? 'lyric current'
                      : 'lyric'
                  }
                  key={`lyric_${index}`}
                >
                  <span>{lyric.word}</span>
                </div>
              );
            })}
        </>
      </div>
    </>
  );
};

export default SlideShow;
